"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NovageSkincareAdvisorController = void 0;
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constantsGenerated = require("../constants-generated");
var _contexts = require("../contexts");
var _logger2 = require("../logger");
var _ApiProvider = require("./ApiProvider");
var _NovageSkincareAdvisor = require("./NovageSkincareAdvisor");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Accepts config data, renders NovageSkincareAdvisor.
 */
const NovageSkincareAdvisorController = ({
  translations
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
  fallback: null,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.Presentation,
    project: _constantsGenerated.APP_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
      logger: _logger2.mainLogger,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
        areaName: "NovageSkincareAdvisorController",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.NovageSkincareAdvisorProvider, {
            translations: translations,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NovageSkincareAdvisor.NovageSkincareAdvisor, {})
          })
        })
      })
    })
  })
});
exports.NovageSkincareAdvisorController = NovageSkincareAdvisorController;
